import { Box } from '@mui/material';
import type { UserProfile } from '../../services/userService';
import { BugReportButton } from '../../features/feedback/BugReportButton';
import { Notifications } from '../../features/notifications';
import { SensitiveDataButton } from '../../features/sensitive-data/components/SensitiveDataButton';
import { ThemeSwitcher } from './ThemeSwitcher';
import { UserMenu } from './UserMenu';

interface HeaderActionsProps {
  userProfile: UserProfile | null;
  profileLoading: boolean;
}

export const HeaderActions = ({ userProfile, profileLoading }: HeaderActionsProps) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.75 }}>
    <ThemeSwitcher />
    <BugReportButton />
    {userProfile?.CanSeeNotifications && (
      <Notifications openButtonLocalization="Open" closeButtonLocalization="Close" />
    )}
    {userProfile?.CanSeeSensitiveDataPassword && <SensitiveDataButton />}
    <UserMenu userProfile={userProfile} loading={profileLoading} />
  </Box>
);
